 

import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

function AddItem() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({ lat: 0, lng: 0 });

  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    condition: "Good",
    minDays: 1,
    maxDays: 30,
    city: "",
    address: "",
    pincode: "",
    pricePerDay: "",
    deposit: "",
  });

  // 🔥 UNIFIED STATE: { file: File | null, preview: string, isCover: boolean }
  const [images, setImages] = useState([]);
  // 🗺️ THE MAGIC FUNCTION: Pincode se Lat/Lng nikalne ka jugaad
  const getCoordinatesFromPincode = async (pincode, city) => {
    try {
      // Free OpenStreetMap API
      const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${pincode}+${city}+India&format=json&limit=1`);
      const data = await res.json();
      
      if (data && data.length > 0) {
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      }
      return null;
    } catch (err) {
      console.error("Map API Error:", err);
      return null;
    }
  };

  // 1. Get Location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => setLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => {}
      );
    }
  }, []);

  // 2. Fetch Item for Edit
  useEffect(() => {
    if (!isEdit) return;
    const fetchItem = async () => {
      try {
        const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`);
        const data = await res.json();
        if (data.success) {
            setFormData({
                title: data.item.title || "",
                category: data.item.category || "",
                description: data.item.description || "",
                condition: data.item.condition || "Good",
                minDays: data.item.minDays || 1,
                maxDays: data.item.maxDays || 30,
                city: data.item.city || "",
                address: data.item.address || "",
                pincode: data.item.pincode || "",
                pricePerDay: data.item.pricePerDay || "",
                deposit: data.item.deposit || "",
            });
            if (data.item.location?.coordinates) {
                 setLocation({ lng: data.item.location.coordinates[0], lat: data.item.location.coordinates[1] });
            }
            // Backend images convert to UI format
            const formattedImages = (data.item.images || []).map(img => ({
                file: null, 
                preview: img.url, 
                isCover: img.isCover,
                _id: img._id
            }));
            setImages(formattedImages);
        }
      } catch (err) { console.error(err); }
    };
    fetchItem();
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleConditionChange = (value) => {
    setFormData((prev) => ({ ...prev, condition: value }));
  };

  // 3. Image Handlers
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file, 
      preview: URL.createObjectURL(file),
      isCover: false, 
    }));
    setImages((prev) => {
        const combined = [...prev, ...newImages];
        if (prev.length === 0 && newImages.length > 0) combined[0].isCover = true;
        return combined;
    });
  };

  const setCoverImage = (index) => {
    setImages((prev) => prev.map((img, i) => ({ ...img, isCover: i === index })));
  };

  const removeImage = (index) => {
    if (images[index].file) URL.revokeObjectURL(images[index].preview);
    setImages((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      if (!updated.some((img) => img.isCover) && updated.length > 0) updated[0].isCover = true;
      return updated;
    });
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // 📍 1. Samundar (0,0) wala logic: GPS Check
  //   const currentLat = location.lat;
  //   const currentLng = location.lng;

  //   if (!currentLat || !currentLng || (currentLat === 0 && currentLng === 0)) {
  //     alert("📍 Location Access Required! Please allow GPS to add this item so neighbors can find it.");
  //     return; 
  //   }

  //   // ⏳ 2. Loading & Token Check
  //   if (loading) return;
  //   setLoading(true);

  //   const token = localStorage.getItem("token");
  //   if (!token) { 
  //     alert("Login required!"); 
  //     setLoading(false); 
  //     return; 
  //   }

  //   try {
  //     const data = new FormData();

  //     // 📝 3. Basic Form Data append karo
  //     Object.entries(formData).forEach(([key, value]) => data.append(key, value));
      
  //     // 🗺️ 4. 🔥 ASLI FIX: Location ko 'lat' aur 'lng' keys ke saath bhejo
  //     data.append("lat", currentLat);
  //     data.append("lng", currentLng);

  //     // 🖼️ 5. Image Logic (Old vs New separation)
  //     const keptImages = images.filter(img => !img.file).map(img => ({
  //         url: img.preview,
  //         isCover: img.isCover,
  //         _id: img._id
  //     }));
  //     const newFiles = images.filter(img => img.file);
      
  //     // Cover index logic (Tells backend which new file is the cover)
  //     const coverIndex = images.findIndex((img) => img.isCover);
  //     data.append("coverIndex", coverIndex === -1 ? 0 : coverIndex);

  //     // New files ko FormData mein daalo
  //     newFiles.forEach((img) => data.append("images", img.file));

  //     // 🚀 6. API Call (Add vs Edit)
  //     if (isEdit) {
  //       // Edit mode mein keptImages zaroori hain taaki backend purani photos delete na kare
  //       data.append("keptImages", JSON.stringify(keptImages));
        
  //       const res = await fetch(`https://borrowhub-backend.onrender.com/api/items/${id}`, {
  //         method: "PUT",
  //         headers: { Authorization: `Bearer ${token}` },
  //         body: data,
  //       });

  //       const result = await res.json();
  //       if (result.success) {
  //         alert("Item updated successfully! ✅");
  //         navigate("/my-items");
  //       } else {
  //         alert(result.message || "Update failed ❌");
  //       }
  //     } else {
  //       // Add Mode
  //       const res = await fetch("https://borrowhub-backend.onrender.com/api/items/add", {
  //         method: "POST",
  //         headers: { Authorization: `Bearer ${token}` },
  //         body: data,
  //       });

  //       const result = await res.json();
  //       if (result.success) { 
  //         alert("Item added successfully! ✨"); 
  //         navigate("/home"); 
  //       } else {
  //         alert(result.message || "Add failed ❌");
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Submit Error:", err);
  //     alert("Something went wrong with the server.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }; 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    let currentLat = location.lat;
    let currentLng = location.lng;

    // 🔥 THE MASTERSTROKE UX: Agar GPS band hai, toh Pincode se location nikaalo!
    if (!currentLat || !currentLng || (currentLat === 0 && currentLng === 0)) {
      
      // Check karo user ne Pincode aur City form mein daala hai ya nahi
      if (!formData.pincode || !formData.city) {
        alert("📍 Location nahi mili! Kripya apna City aur Pincode sahi se daalein.");
        setLoading(false);
        return;
      }

      // API call karke coordinates laao
      const fallbackCoords = await getCoordinatesFromPincode(formData.pincode, formData.city);

      if (fallbackCoords) {
        currentLat = fallbackCoords.lat;
        currentLng = fallbackCoords.lng;
      } else {
        alert("📍 Sahi Pincode aur City daaliye, ya browser mein GPS allow kariye.");
        setLoading(false);
        return;
      }
    }

    const token = localStorage.getItem("token");
    if (!token) { alert("Login required"); setLoading(false); return; }

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => data.append(key, value));
      
      // ✅ Ab chahe GPS se aaye ya Pincode se, backend ko sahi data jayega!
      data.append("lat", currentLat);
      data.append("lng", currentLng);

      const keptImages = images.filter(img => !img.file).map(img => ({
          url: img.preview, isCover: img.isCover, _id: img._id
      }));
      const newFiles = images.filter(img => img.file);
      
      const coverIndex = images.findIndex((img) => img.isCover);
      data.append("coverIndex", coverIndex === -1 ? 0 : coverIndex);
      newFiles.forEach((img) => data.append("images", img.file));

      if (isEdit) {
        data.append("keptImages", JSON.stringify(keptImages));
        const res = await fetch(`https://borrowhub-backend.onrender.com/api/items/${id}`, {
          method: "PUT", headers: { Authorization: `Bearer ${token}` }, body: data,
        });
        const result = await res.json();
        if (result.success) { alert("Item updated! ✅"); navigate("/my-items"); } 
        else alert(result.message || "Update failed");
      } else {
        const res = await fetch("https://borrowhub-backend.onrender.com/api/items/add", {
          method: "POST", headers: { Authorization: `Bearer ${token}` }, body: data,
        });
        const result = await res.json();
        if (result.success) { alert("Item added successfully! ✨"); navigate("/home"); } 
        else alert(result.message || "Add failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) { alert("Deleted!"); navigate("/my-items"); }
    } catch (err) { alert("Error deleting"); }
  };

  return (
    <div className="bg-light min-vh-100">
      <form onSubmit={handleSubmit}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center px-4 py-3 bg-white border-bottom">
          <img src="/logo.png" alt="BorrowHub" height="110" />
          <button type="button" className="btn btn-outline-success" onClick={() => navigate(-1)}>Cancel</button>
        </div>

        <div className="container mt-4">
          <h2 className="fw-bold text-success">{isEdit ? "Edit Item" : "Add New Item"}</h2>
          <p className="text-muted">List your item and start lending to the community</p>
        </div>

        <div className="container my-4">
          <div className="card border-0 shadow-sm p-4 rounded-4">
            <h5 className="fw-bold mb-3 text-success">Basic Information</h5>

            <div className="mb-3">
              <label className="form-label">Item Name *</label>
              <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Category *</label>
              <input className="form-control" list="categories" name="category" value={formData.category} onChange={handleChange} required />
              <datalist id="categories">
                <option value="Electronics" /><option value="Tools" /><option value="Clothing" />
                <option value="Books" /><option value="Furniture" /><option value="Sports" />
              </datalist>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Rental Price (₹/day) *</label>
                <input type="number" name="pricePerDay" value={formData.pricePerDay} onChange={handleChange} className="form-control" required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Security Deposit (₹)</label>
                <input type="number" name="deposit" value={formData.deposit} onChange={handleChange} className="form-control" />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">Location *</label>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <input type="text" className="form-control" placeholder="City" name="city" value={formData.city} onChange={handleChange} required />
                </div>
                <div className="col-md-4 mb-3">
                  <input type="text" className="form-control" placeholder="Area / Landmark" name="address" value={formData.address} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <input type="text" className="form-control" placeholder="Pincode" name="pincode" value={formData.pincode} onChange={handleChange} maxLength="6" required />
                </div>
              </div>
            </div>

            {/* 🟢 Upload Images (TERA WALA UI) */}
            <h5 className="fw-bold mb-3 text-success">Upload Images</h5>

            <input type="file" id="itemImages" multiple accept="image/*" hidden onChange={handleImageChange} />

            <label htmlFor="itemImages" className="border border-2 border-dashed rounded-3 p-4 text-center text-muted w-100" style={{ cursor: "pointer" }}>
              <p className="mb-1 fw-semibold text-success">Click to upload or drag and drop</p>
              <small>PNG, JPG or WEBP (max. 5MB)</small>
            </label>

            <div className="row g-3 mt-2">
              {images.map((img, index) => (
                <div className="col-3" key={index}>
                  <div className="position-relative border rounded p-1">
                    <img
                      src={img.preview}
                      alt="preview"
                      className="img-fluid rounded"
                      style={{ height: "120px", objectFit: "cover", width: "100%" }}
                    />

                    {img.isCover && (
                      <span className="badge bg-success position-absolute top-0 start-0">
                        Cover
                      </span>
                    )}

                    <div className="d-flex justify-content-between mt-1">
                      {!img.isCover && (
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-success"
                          onClick={() => setCoverImage(index)}
                        >
                          Set Cover
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeImage(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h5 className="fw-bold mt-4 mb-3 text-success">Item Details</h5>
            <textarea className="form-control" rows="4" name="description" value={formData.description} onChange={handleChange} required />

            <label className="form-label mt-3">Condition *</label>
            <div className="d-flex gap-3 mb-3">
              {["Excellent", "Good", "Fair", "Poor"].map((c) => (
                <button
                  key={c} type="button"
                  className={`btn btn-outline-success ${formData.condition === c ? "active" : ""}`}
                  onClick={() => handleConditionChange(c)}
                >
                  {c}
                </button>
              ))}
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Minimum Days</label>
                <input type="number" className="form-control" name="minDays" value={formData.minDays} onChange={handleChange} min={1} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Maximum Days</label>
                <input type="number" className="form-control" name="maxDays" value={formData.maxDays} onChange={handleChange} min={1} />
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="d-flex justify-content-between align-items-center">
            {isEdit && (
              <button type="button" className="btn btn-danger me-auto" onClick={handleDelete}>🗑️ Delete Item</button>
            )}
            <button type="submit" className={`btn ${isEdit ? "btn-primary" : "btn-success"}`} disabled={loading}>
              {loading ? (
                <> <span className="spinner-border spinner-border-sm me-2"></span>{isEdit ? "Updating..." : "Adding..."} </>
              ) : (
                isEdit ? "Update Item ✅" : "Add Item ✨"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddItem;